import React from 'react'
import Navigation from '../components/navigation'

const NavbarPage = () => {
  return (
    <React.Fragment>
        <Navigation/>
    </React.Fragment>
  )
}

export default NavbarPage